import { securedAppApi } from "./securedApi";

const GET_ALL_USERS = '/identity/user';
const Add_USERS = '/identity/user';
const GET_USERS_ROLES = '/identity/user/roles';
const GET_USERS_ROLESID = '/identity/user/roleId';
const EXPORT_USERS_ROLES = '/identity/user/export';
const GET_USERS_INDIVIDUAL_ID = 'v1/Individuals/GetIndividualIdbyEmail'
const CHANGE_PASSWORD = '/identity/account/ChangePassword';
const GET_USERS_WITH_ROLE_BY_ORGANIZATION_ID = '/identity/user/GetUsersWithRoleByOrganizationId';
export const usersApiHandler = securedAppApi.injectEndpoints({
    endpoints: builder => ({
        getUsers: builder.query({
            query: () =>
                GET_ALL_USERS + `/UsersWithRoles`
        }),
        addUsers: builder.mutation({
            query: (addUsers) => ({
                url: Add_USERS,
                method: 'POST',
                body: addUsers,
            }),
        }),
        GetUsersById: builder.query({
            query: ({ id }) =>
                GET_ALL_USERS + `/${id}`
        }),
        GetUserRoles: builder.query({
            query: ({ id }) =>
                GET_USERS_ROLES + `/${id}`
        }),
        GetUserRoleId: builder.query({
            query: ({ id }) =>
                GET_USERS_ROLESID + `/${id}`
        }),
        ExportUsers: builder.query({
            query: () =>
                EXPORT_USERS_ROLES
        }),
        GetEmailByIndividualId: builder.query({
            query: ({ primaryEmail }) =>
                GET_USERS_INDIVIDUAL_ID + `?primaryEmail=${primaryEmail}`
        }),
        changePassword: builder.mutation({
            query: (changePassword) => ({
                url: CHANGE_PASSWORD,
                method: 'PUT',
                body: changePassword,
            }),
        }),
        GetUsersWithRoleByOrganizationId: builder.query({
            query: ({ organizationIds, search, pageNumber = 1, pageSize = 10 }) => {
                const params = new URLSearchParams();
                organizationIds?.forEach((id: string) => params.append("organizationIds", id));
                if (search) params.append("search", search);
                params.append("pageNumber", pageNumber);
                params.append("pageSize", pageSize);
                return `${GET_USERS_WITH_ROLE_BY_ORGANIZATION_ID}?${params.toString()}`;
            }
        }),

    })
});

export const {
    useGetUsersQuery, useAddUsersMutation, useGetUsersByIdQuery, useGetUserRolesQuery, useExportUsersQuery, useGetEmailByIndividualIdQuery, useGetUserRoleIdQuery,
    useChangePasswordMutation, useGetUsersWithRoleByOrganizationIdQuery
} = usersApiHandler 